import apiService from '../apiService';

// Libellés du système d'avis unifié (admin, français).
export const TARGET_LABELS = {
  driver_taxi: 'Chauffeur (course)', client: 'Client', deliverer: 'Livreur', supplier: 'Commerce', product: 'Produit',
  lodging: 'Hébergement', beauty_salon: 'Institut de beauté', rental_agency: 'Agence de location', rental_driver: 'Chauffeur (location)',
};
export const CONTEXT_LABELS = {
  ride: 'Course', delivery_order: 'Commande', parcel: 'Colis', lodging_booking: 'Séjour', beauty_booking: 'Rendez-vous', vehicle_rental: 'Location',
};
export const STATUS_META = {
  published: { label: 'Publié', color: '#166534', bg: '#ECFDF5' },
  flagged: { label: 'Masqué', color: '#B45309', bg: '#FEF3C7' },
  removed: { label: 'Retiré', color: '#991B1B', bg: '#FEE2E2' },
};

// Critères (tags) chargés une seule fois : clé → { label fr, positive }
let criteriaPromise = null;
export function loadCriteria() {
  if (!criteriaPromise) {
    criteriaPromise = apiService.get('/reviews/criteria', { userType: 'admin' })
      .then(res => {
        const map = {};
        const c = (res && res.criteria) || {};
        for (const [target, lists] of Object.entries(c)) {
          for (const t of lists.positive || []) map[`${target}:${t.key}`] = { label: t.label?.fr || t.key, positive: true };
          for (const t of lists.negative || []) map[`${target}:${t.key}`] = { label: t.label?.fr || t.key, positive: false };
        }
        return { map, min_count_display: res?.min_count_display ?? 5 };
      })
      .catch(() => { criteriaPromise = null; return { map: {}, min_count_display: 5 }; });
  }
  return criteriaPromise;
}

export function tagMeta(criteria, targetType, key) {
  return (criteria && criteria[`${targetType}:${key}`]) || { label: String(key).replace(/_/g, ' '), positive: null };
}

export const stars = (n) => '★'.repeat(n) + '☆'.repeat(5 - n);
export const fmtDate = (d) => (d ? new Date(d).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
